import React from 'react';
import { X } from 'lucide-react';
import { ScanTextInput } from '../../../../common/inputs';

interface LocationScanModalProps {
  isOpen: boolean;
  expectedLocation: string;
  tempGS1Quantity?: number | null;
  locationScan: string;
  onLocationScanChange: (value: string) => void;
  onConfirm: () => void;
  onOverride: () => void;
  onClose: () => void;
}

export const LocationScanModal: React.FC<LocationScanModalProps> = ({
  isOpen,
  expectedLocation,
  tempGS1Quantity,
  locationScan,
  onLocationScanChange,
  onConfirm,
  onOverride,
  onClose
}) => {
  if (!isOpen) return null;

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onConfirm();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-0 sm:p-4">
      <div className="bg-white w-full h-full sm:h-auto sm:rounded-lg p-4 sm:p-6 sm:max-w-md overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Skann lokasjon</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 min-h-[44px] min-w-[44px] flex items-center justify-center"
          >
            <X size={24} />
          </button>
        </div>
        
        <p className="text-sm text-gray-600 mb-4">
          Forventet lokasjon: <span className="font-medium">{expectedLocation}</span>
          {tempGS1Quantity && (
            <><br/>Antall: <span className="font-medium text-blue-600">{tempGS1Quantity}</span></>
          )}
        </p>
        
        <ScanTextInput
          placeholder="Skann lokasjon"
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 mb-4 min-h-[44px]"
          value={locationScan}
          onChange={(e) => onLocationScanChange(e.target.value)}
          onKeyPress={handleKeyPress}
          autoFocus
        />

        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={onConfirm}
            className="flex-1 bg-blue-600 text-white py-3 sm:py-2 rounded-lg hover:bg-blue-700 min-h-[44px] order-1"
          >
            Bekreft
          </button>
          <button
            onClick={onOverride}
            className="flex-1 bg-gray-600 text-white py-3 sm:py-2 rounded-lg hover:bg-gray-700 min-h-[44px] order-2"
          >
            Overstyr
          </button>
          <button
            onClick={onClose}
            className="px-4 py-3 sm:py-2 border border-gray-300 rounded-lg hover:bg-gray-50 min-h-[44px] order-3"
          >
            Avbryt
          </button>
        </div>
      </div>
    </div>
  );
};